import type { ComandoTransicao } from '../../../types/gmud'

/**
 * Quais ações a tela pinta de vermelho e confirma antes de executar.
 *
 * Isto é APARÊNCIA, não regra. Não acrescenta ação nenhuma, não habilita nada e não impede
 * nada: quais botões existem e quais estão habilitados continua vindo inteiro de
 * `/transicoes-possiveis`. O que esta lista decide é a cor do botão e se cabe um "tem certeza?"
 * — e comando que não esteja aqui sai com a aparência neutra, sem sumir da tela.
 *
 * O critério é o efeito sobre trabalho já feito: desfazer uma aprovação, voltar uma implantação
 * já aplicada em produção ou encerrar a solicitação em negativa. Errar por excesso aqui custa um
 * clique a mais; errar por falta custa uma aprovação revogada sem querer, numa reunião de comitê,
 * por alguém que ia clicar no botão do lado.
 */
const DESTRUTIVAS: ComandoTransicao[] = [
  'DECIDIR_CAB_REJEITAR',
  'REVOGAR_APROVACAO',
  'APLICAR_ROLLBACK',
  'REPROVAR_VERIFICACAO',
  // Cancelar é terminal e sem volta: a matriz não dá saída de CANCELADA. Um clique por engano
  // aqui não se conserta reabrindo — conserta-se abrindo outra solicitação, com outro código.
  'CANCELAR',
]

/**
 * @param comando o comando que o servidor ofereceu
 * @returns true quando a ação desfaz trabalho já feito ou encerra a solicitação em negativa
 */
export function ehDestrutiva(comando: ComandoTransicao): boolean {
  return DESTRUTIVAS.includes(comando)
}
